<template>
  <div v-show="isActive">
    <slot />
  </div>
</template>

<script>
  import { inject, computed, onMounted, onBeforeUnmount, watch, toRef } from 'vue';

  export default {
    name: 'TabItem',
    props: {
      name: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
        default: null,
      },
      badge: {
        type: [String, Number],
        default: null,
      },
    },
    setup(props) {
      const addTab = inject('addTab');
      const updateTab = inject('updateTab', null);
      const removeTab = inject('removeTab', null);
      const activeTab = inject('activeTab');

      onBeforeUnmount(() => {
        if (removeTab) removeTab(props.name);
      });

      onMounted(() => {
        addTab({
          title: props.title,
          name: props.name,
          icon: props.icon,
          badge: props.badge,
        });
      });

      // Watch for badge changes and update tab
      watch(
        () => props.badge,
        (newBadge) => {
          if (updateTab) {
            updateTab(props.name, { badge: newBadge });
          }
        }
      );

      const isActive = computed(() => {
        return activeTab.value === props.name;
      });

      return {
        isActive,
      };
    },
  };
</script>

<style scoped>
  /* Add any styles you need here */
</style>
